import React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { LabeledCheckbox } from '../components/LabeledCheckbox';
import { Goals, GoalValuePrefix } from './formValuesModel';
import { useIsNarrowForm } from './ResponsiveFormContext';
/** Below this window width, phone sign-up shows goals in one column. */
const ONE_COLUMN_WIDTH = 380;
export const GoalsCheckboxGrid = (props) => {
    // Three columns, except on phone-sized public sign-up (two, or one).
    const narrow = useIsNarrowForm();
    const { width: windowWidth } = useWindowDimensions();
    const columnCount = narrow ? (windowWidth < ONE_COLUMN_WIDTH ? 1 : 2) : 3;
    const renderCheckboxColumns = () => {
        const columns = Array.from({ length: columnCount }, () => []);
        Goals.forEach((goal, index) => {
            const name = `${GoalValuePrefix}${goal.name}`;
            columns[index % columnCount].push(<LabeledCheckbox key={name} name={name} label={goal.label} checked={props.goalValues[name]} readOnly={props.readOnly}/>);
        });
        return (<View style={styles.row}>
        {columns.map((column, columnIndex) => (<View key={columnIndex} style={styles.column}>
            {column}
          </View>))}
      </View>);
    };
    return <View style={styles.container}>{renderCheckboxColumns()}</View>;
};
const styles = StyleSheet.create({
    container: {
        marginVertical: 20,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    column: {
        flex: 1,
    },
});
